import { Controller } from '@hotwired/stimulus';

/**
 * Reminder compose - keeps the "when" quick picks and the "who" options in sync with the form.
 * Targets: pick (quick-pick buttons) | when (datetime-local input) | audience (radios) |
 *          membersRadio (hidden "some people" radio per group) | member (checkboxes) | group (group cards) |
 *          submit / submitLabel (the create button and its text)
 * Params:  pick has `time` (value for the datetime-local input)
 */
export default class extends Controller {
  static targets = ['pick', 'when', 'audience', 'membersRadio', 'member', 'group', 'submit', 'submitLabel'];

  connect () {
    this.syncPicks();
    this.audienceChanged();
  }

  pick (event) {
    this.whenTarget.value = event.params.time;
    this.syncPicks();
  }

  customChanged () {
    this.syncPicks();
  }

  memberChanged (event) {
    const groupId = event.target.dataset.groupId;
    const radio = this.membersRadioTargets.find((item) => item.dataset.groupId === groupId);
    const anyChecked = this.memberTargets.some((item) => item.dataset.groupId === groupId && item.checked);

    this.memberTargets.forEach((item) => {
      if (item.dataset.groupId !== groupId) item.checked = false;
    });

    if (radio && anyChecked) {
      radio.checked = true;
    } else if (radio && radio.checked) {
      // nobody picked anymore: fall back to "just me"
      const onlyMe = this.audienceTargets.find((item) => item.value === 'only_me');
      if (onlyMe) onlyMe.checked = true;
    }

    this.audienceChanged();
  }

  audienceChanged () {
    const selected = this.audienceTargets.find((item) => item.checked);

    if (selected && !this.membersRadioTargets.includes(selected)) {
      this.memberTargets.forEach((item) => { item.checked = false; });
    }

    this.groupTargets.forEach((group) => {
      group.classList.toggle('who-group--active', Boolean(selected) && group.contains(selected));
    });

    this.#updateSubmitLabel(selected);
  }

  syncPicks () {
    const current = this.whenTarget.value;
    this.pickTargets.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.reminderComposeTimeParam === current));
    });
  }

  #updateSubmitLabel (selected) {
    if (!this.hasSubmitLabelTarget) return;

    let label = this.submitTarget.dataset.defaultLabel;
    if (selected && this.membersRadioTargets.includes(selected)) {
      const names = this.memberTargets.filter((item) => item.checked).map((item) => item.dataset.name);
      const shown = names.length > 2 ? `${names.slice(0, 2).join(', ')} +${names.length - 2}` : names.join(', ');
      label = this.submitTarget.dataset.membersLabel.replace('%{names}', shown);
    } else if (selected && selected.dataset.submitLabel) {
      label = selected.dataset.submitLabel;
    }

    this.submitLabelTarget.textContent = label;
  }
}
